export const releases = [{
  key : "1.3.23",
  date: "September 14, 2026",
  items: [{
    cat: "Site Feasibility Questionnaire",
    status: "announcement",
    descr: `<b>Site Feasibility Questionnaire 추가</b>
             <ul>
              <li>시험별 설문 생성, 템플릿 관리, 기관 초대 및 응답 확인 기능 추가</li>
             </ul>`,
  }]
}, {
  key : "1.3.22",
  date: "June 12, 2026",
  items: [{
    cat: "Common",
    status: "changed",
    descr: `<b>보안 강화</b>
             <ul>
              <li>로그인 토큰 저장 방식을 sessionStorage에서 JWT Cookie 방식으로 변경</li>
              <li>파일 업로드 시 인증 쿠키 자동 전송 적용 (withCredentials)</li>
              <li>HTTPS/SSL 인증서 적용</li>
             </ul>`,
  }, {
    cat: "Organization",
    status: "announcement",
    descr: `<b>권한 관리 화면 추가</b>
             <ul>
              <li>권한 목록(Permission List) 화면 추가</li>
              <li>권한 매트릭스(Permission Matrix) 화면 추가</li>
             </ul>`,
  }, {
    cat: "Common",
    status: "changed",
    descr: `<b>서버 환경 구성</b>
             <ul>
              <li>개발(Development) / 스테이징(Staging) / 운영(Production) 환경 분리</li>
              <li>스테이징 서버 구축 — 운영 배포 전 검증 환경으로 활용</li>
             </ul>`,
  }, {
    cat: "Project Setup",
    status: "changed",
    descr: `<b>견적서 업로드 개선</b>
             <ul>
              <li>견적서 업로드 시 새로운 version 인 경우 자동 생성</li>
              <li>견적서 업로드 시 새로운 항목이 있는 경우 자동으로 추가</li>
              <li>동일 type/ver에서 카테고리명이 변경된 경우 업로드를 차단하고 오류 메시지 반환</li>
             </ul>`,
  }, {
    cat: "Common",
    status: "fixed",
    descr: `<b>오류 수정</b>
             <ul>
              <li>Contract Registration 견적 목록(Quotation List) 헤더 클릭 시 오류 수정</li>
              <li>DevExtreme 라이브러리 업데이트로 "Invalid value used as weak map key" 오류 해결</li>
              <li>권한 오류 수정</li>
             </ul>`,
  }, {
    cat: "TRAINING",
    status: "fixed",
    descr: `<b>Training Tracker 개선</b>
             <ul>
              <li>Training Tracker 에 입력된 교육 제목과 My Record 에 등록된 교육 제목 사이의 공백 불일치로 인해 매칭이 되지 않는 오류 수정</li>
              <li>Trainee 가 My Record 입력 후 삭제, 재입력 시 업데이트가 안되어서 조회가 안되는 이슈 수정</li>
             </ul>`,
  }]
}, {
  key : "1.3.21",
  date: "October 15, 2025",
  items: [{
    cat: "Work Record",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Fix the Issue of "Classification of Work", "Task", and "Detailed Task" Not Showing on the Review Screen</li>
              <li>Fix the Issue of "Detailed Task" Missing in user's Work Record Form</li>
             </ul>`,
  }, {
      cat: "Work Record",
      status: "changed",
      descr: `<b>Functional Maintenance</b>
               <ul>
                <li>Hide the Copy button on the review screen.</li>
                <li>Implement automatic copying of the 'Detailed Task' to the 'Subject' field upon selection (excluding when 'Other' is selected).</li>
                <li>Display the full Subject in the Scheduler Appointment.</li>
                <li>Display Break Times and Holidays.</li>
               </ul>`,
    }
  ]
}, {
  key : "1.3.20",
  date: "September 19, 2025",
  items: [{
    cat: "Work Record",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Added "Project" to the classification of an RA's work.</li>
             </ul>`,
  }, {
      cat: "Work Record",
      status: "changed",
      descr: `<b>Data Maintenance</b>
               <ul>
                <li>Updated the detailed tasks for the RA's task categories.</li>
               </ul>`,
    }
  ]
}, {
  key : "1.3.19",
  date: "August 28, 2025",
  items: [{
    cat: "SOP Viewer",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Added the watermark to PDF Viewer</li>
             </ul>`,
  }]
}, {
  key : "1.3.18",
  date: "August 20, 2025",
  items: [{
    cat: "SOP Viewer",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Updated Form and Template documents by converting them to PDF.</li>
             </ul>`,
  }, {
    cat: "SOP Viewer",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Reimplemented PDF Viewer</li>
             </ul>`,
  }]
},{
  key : "1.3.17",
  date: "July 2, 2025",
  items: [{
    cat: "Clinical Trial Status by Indication",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Restructure the Site/Investigator Grid and add Excel export functionality</li>
             </ul>`,
  }]
}, {
  key : "1.3.16",
  date: "July 2, 2025",
  items: [{
    cat: "Project Setup",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Change how we modify contract data from Batch to Popup</li>
              <li>Add Project Status and Priority to the Contract Grid</li>
             </ul>`,
  }, {
    cat: "Monthly Report",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Add the "Sum Field" to Configuration Grid</li>
              <li>Change the display value of "Issue" in the Project List of the Report</li>
              <li>Add zoom in/out functionality to the Project List of the Report</li>
             </ul>`,
  }]
},{
  key : "1.3.15",
  date: "April 30, 2025",
  items: [{
    cat: "Training",
    status: "announcement",
    descr: `<b>Training Tracker</b>
             <ul>
              <li>Add a Tracker feature to check the training completion status</li>
              <ul>
                      <li><a href="https://beccocro.gitbook.io/manual/manual/betree/training/training-tracker" target="_blank">Manual</a></li>
                    </ul>
             </ul>`,
  }, {
    cat: "Training",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Modify "Training Report" editing logic</li>
             </ul>`,
  }]
},{
  key : "1.3.14",
  date: "December 17, 2024",
  items: [{
    cat: "Monthly Report",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
            <ul>
              <li>Delete header filter row in datagrid for target enrollment.</li>
            </ul>`,
  }]
}, {
  key : "1.3.13",
  date: "December 16, 2024",
  items: [{
    cat: "Monthly Report",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
            <ul>
              <li>Define the dateSerializationFormat of the deadline of the project status.</li>
            </ul>`,
  }]
}, {
  key : "1.3.12",
  date: "November 28, 2024",
  items: [{
    cat: "Common",
    status: "changed",
    descr: `<b>BeTree Main</b>
            <ul>
              <li>Change the main menu</li>
            </ul>`,
  }]
},{
  key : "1.3.11",
  date: "November 26, 2024",
  items: [{
    cat: "SOP",
    status: "changed",
    descr: `<b>Data Maintenance</b>
            <ul>
              <li>The RA's SOP update</li>
            </ul>`,
  }]
}, {
  key : "1.3.10",
  date: "October 30, 2024",
  items: [{
    cat: "New Drug Clinical Trial Institution Info.",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Revise the caption, changing "검사기관" to "실시기관".</li>`
  }]
},{
  key : "1.3.9",
  date: "September 4, 2024",
  items: [{
    cat: "New Drug Clinical Trial Info.",
    status: "announcement",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Implement a functionality to store and reuse filter values.</li>`
  }]
},{
  key : "1.3.8",
  date : "August 27, 2024",
  items : [{
    cat: "Work Record",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Change task list display logic</li>
             </ul>`,
  }]
}, {
  key : "1.3.7",
  date : "August 20, 2024",
  items : [{
    cat: "Monthly Report",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Modified the enrollment status update logic and the cumulative number of subjects calculation logic</li>
             </ul>`,
  }, {
    cat: "Monthly Report",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Added a function to change priority</li>
             </ul>`,
  }]
}, {
  key : "1.3.6",
  date : "August 13, 2024",
  items : [{
    cat: "Monthly Report",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Modify the loading and display logic of the issue list</li>
             </ul>`,
  }]
},{
  key : "1.3.5",
  date : "July 31, 2024",
  items : [{
    cat: "Project Assign",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>JD Change "SA" to "STAT"</li>
             </ul>`,
  }, {
    cat: "Work Record",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Change the SEQ type of detailed task</li>
             </ul>`,
  }, {
    cat: "Clinical Trials Status by Indictation",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Change favicon url for ClinicalTrials.gov</li>
             </ul>`,
  }, {
    cat: "New Drug Clinical Trial Info.",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Change favicon url for ClinicalTrials.gov</li>
             </ul>`,
  }, {
    cat: "New Drug Clinical Trial Institution Info.",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Change favicon url for ClinicalTrials.gov</li>
             </ul>`,
  }]
},{
  key : "1.3.4",
  date : "July 26, 2024",
  items : [{
    cat: "Work Record",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>"Detailed task" sorting logic modified</li>
             </ul>`,
  }]
},{
  key : "1.3.3",
  date : "July 23, 2024",
  items : [{
    cat: "Contract Registration",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>Update RA task in task metadata</li>
              <li>RA quotation registrion</li>
             </ul>`,
  }, {
    cat: "Contract Registration",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Modification of quotation upload logic according to RA quotation</li>
             </ul>`,
  }, {
    cat: "Project Assign",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Add RA JD</li>
             </ul>`,
  }]
},{
  key : "1.3.2",
  date : "July 16, 2024",
  items : [{
    cat: "Monthly Report",
    status: "changed",
    descr: `<b>Data Maintenance</b>
             <ul>
              <li>JD update</li>
             </ul>`,
  }]
}, {
  key : "1.3.1",
  date : "July 15, 2024",
  items : [{
    cat: "Project Assign",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Modify project assignment email notification logic</li>
             </ul>`,
  },{
    cat: "Common",
    status: "changed",
    descr: `<b>Contract No.</b>
             <ul>
              <li>Contract No. definition modification</li>
             </ul>`,
  }]
}, {
  key : "1.3.0",
  date : "July 12, 2024",
  items : [{
    cat: "Contract Registration",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Apply quotation template</li>
              <ul>
                <li>Task metadata definition by phase and version</li>
                <li>Apply updates to existing projects and register new projects</li>
              </ul>
             </ul>`,
  }, {
    cat: "Project Assign",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Edit JD</li>
             </ul>`,
  }, {
    cat: "Work Record",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Apply task metadata</li>
             </ul>`,
  }, {
    cat: "Monthly Report",
    status: "announcement",
    descr: `<b>Monthly Report</b>
             <ul>
              <li>Add Monthly Report/Issue Management</li>
              <ul>
                      <li><a href="https://beccocro.gitbook.io/manual/manual/betree/monthly-report" target="_blank">Manual</a></li>
                    </ul>
             </ul>`,
  }]
},{
  key : "1.2.4",
  date : "May 23, 2024",
  items : [{
    cat: "Training",
    status: "changed",
    descr: `<b>Functional Maintenance</b>
             <ul>
              <li>Exclude Internal_Lecture program from My record</li>
             </ul>`,
  }]
}, {
  key : "1.2.3",
  date : "May 20, 2024",
  items : [{
    cat: "Training",
    status: "fixed",
    descr: `<b>Error Maintenance</b>
             <ul>
              <li>Modify "Training Report" editing logic</li>
             </ul>`,
  }]
},{
  key : "1.2.2",
  date : "May 17, 2024",
  items : [{
    cat: "Bulletin Board",
    status: "changed",
    descr : `<b>Data Maintenance</b>
             <ul><li>Add "Monthly Report" to category</li></ul>`
  },{
    cat: "Work Record",
    status: "changed",
    descr : `<b>Data Maintenance</b>
             <ul><li>Add "Other" to CEO's department work</li></ul>`
  }]
},
  {
    key : "1.2.1",
    date: "May 08, 2024",
    items: [{
      cat: "Training",
      status: "changed",
      descr: `<b>Data Maintenance</b>
              <ul><li>Add "RA" to category</li></ul>`
    }]
  },

  {
    key: "1.2.0",
    date: "October 10, 2023",
    items: [
      {
        cat: "Common",
        status: "announcement",
        descr: `<b>Release Notes</b>
           <ul>
            <li>Add release notes</li>
           </ul>`,
      },
      {
        cat: "Bulletin Board",
        status: "announcement",
        descr: `<b>Bulletin Board</b>
                  <ul>
                    <li>Add bulletin board</li>
                    <ul>
                      <li><a href="https://app.gitbook.com/o/yWUT57DOCjFhm9NpBN4s/s/gY7YYhg9nhaKuOvtMR5y/manual/start/undefined" target="_blank">Manual</a></li>
                    </ul>
                  </ul>`,
      },
    ],
  },
  {
    key: "1.1.0",
    date: "September 15, 2023",
    items: [
      {
        cat: "Qualification",
        status: "announcement",
        descr: `<b>CSL Vifor</b>
                <ul>
                  <li>Add audit Document Viewer</li>
                </ul>`,
      },
    ],
  },
  {
    key: "1.0.2",
    date: "September 13, 2023",
    items: [
      {
        cat: "Qualification",
        status: "changed",
        descr: `<b>CSL Vifor</b>
                <ul>
                  <li>Restrict download permissions for reviewers on the SOP page</li>
                </ul>`,
      },
      {
        cat: "SOP",
        status: "changed",
        descr: `<b>Data Maintenance</b>
                <ul>
                  <li>Edit Effective Date</li>
                </ul>`,
      },
    ],
  },
  {
    key: "1.0.1",
    date: "September 06, 2023",
    items: [
      {
        cat: "Equipment Management",
        status: "changed",
        descr: `<b>Functional Maintenance</b>
                <ul>
                  <li>Permission Settings</li>
                  <ul>
                    <li>Gtant page access only to jd="IT Manager" or div="SRD"</li>
                  </ul>
                </ul>`,
      },
      {
        cat: "Training",
        status: "fixed",
        descr: `<b>Error Maintenance</b>
                 <ul>
                  <li>Edit training report update file path</li>
                 </ul>`,
      },
    ],
  },
  {
    key: "1.0.0",
    date: "September 04, 2023",
    items: [
      {
        cat: "Common",
        status: "announcement",
        descr: `<b>BeTree Setup, Transfer & Test</b>
                <ul>
                  <li>Create a <a href="https://beccocro.gitbook.io/betree-setup/" target="_blank">setup manual</a></li>
                  <li>Connect domain with http://betree.beccocro.com</li>
                  <li>SQL Server email setup</li>
                  <li>SSL certificate issurance/setting</li>
                </ul>`,
      },
      {
        status: "announcement",
        descr: `<b>BeTree Main</b>
                <ul>
                  <li>Change to the BeTree</li>
                  <ul>
                    <li>Master update</li>
                    <li>Open together with BeTree server transfer</li>
                    <li>Img &rarr; SVG</li>
                    <li>Delete Header from Main</li>
                  </ul>
                </ul>`,
      },
    ],
  },
];
